export const STEPS = {
  SCORE: 'SCORE',
  FEEDBACK: 'FEEDBACK',
  FINISHED: 'FINISHED',
};
